import { formatCurrency } from './formatters';

// Mirror of Ruby `Company#max_revenue_input`: the per-tenant ceiling on any single
// advisor-entered revenue field. null/undefined/'' = no cap.
export const hasRevenueCap = (max) => max !== null && max !== undefined && max !== '' && !Number.isNaN(Number(max));

export const exceedsRevenueCap = (value, max) => hasRevenueCap(max) && Number(value) > Number(max);

// `template` may carry a `%{max}` placeholder (onboarding keeps per-locale copy).
export const revenueCapMessage = (max, template = 'Value should not exceed %{max}') =>
  template.replace('%{max}', formatCurrency(Number(max)));
